<template>
    <div class="py-12">
        <v-data-table
            :headers="headers"
            :items="items"
            :itemsPerPage="pagination.rowsPerPage"
            :options.sync="pagination"
            hide-default-footer
            class="elevation-1"
        >
            <template v-slot:body="props">
                <tr v-for="item in props.items" v-bind:key="item.id">
                    <td class="text-xs-right">{{ item.time }}</td>
                    <td class="text-xs-right text-capitalize">{{ item.name | fix_spaces }} <br /> <span class="font-weight-thin caption" >{{ item.job }}</span></td>
                    <td class="text-xs-right">{{ item.ip }} <br /> <span class="font-weight-thin caption" >{{ item.meta['request_url'] }}</span></td>
                    <td class="text-xs-right" @click="$emit('showEventDetails', item)">
                        <v-btn v-if="showDetailsIcon(item)" tile color="primary" outlined>
                            <v-icon>mdi-file-image</v-icon>
                        </v-btn>
                    </td>
                </tr>
            </template>
        </v-data-table>
        <div class="text-xs-center pt-2">
            <v-pagination v-model="pagination.page" :length="pages" @input="pageChanged"></v-pagination>
        </div>
    </div>
</template>

<script>

export default {
    name: 'Analytics',
    props: ['showAnalytics'],
    data: () => ({
            dataType: "events",
            pagination: {page: 1, rowsPerPage: 50, totalItems: 0},
            headers: [
                { text: 'Time'},
                { text: 'Event', align: 'left'},
                { text: 'Source'},
                { text: 'Job' }
            ],
        items: []
    }),

    methods: {
        pageChanged() {
            this.getPageData("events");
        },
        getPageData(dataType) {
            this.dataType = dataType;
            var filterPrefix = '';
            if (dataType == 'jobs') {
                filterPrefix = '&starts_with=job';
            } else if (dataType == 'contacts') {
                filterPrefix = '&starts_with=contact';
            }
            this.$http
                .get(this.getHost() + 'api/event?page=' + this.pagination.page + "&rows=" + this.pagination.rowsPerPage + filterPrefix)
                .then(function(data) {
                    console.log(data);
                    if (data.status == 200) {
                        this.items = data.body['items'];
                        this.pagination.totalItems = data.body['total_items'];
                        this.pagination.rowsPerPage = data.body['rows'];
                    }
                });
        },
        showDetailsIcon: function(item) {
            return item.job || item.name == "contact";
        }
    },
    computed: {
        pretty: function() {
            return this.item.id
        },
        pages () {
            if (this.pagination.rowsPerPage == null ||
            this.pagination.totalItems == null
            ) return 0
            return Math.ceil(this.pagination.totalItems / this.pagination.rowsPerPage)
        }
    },
    mounted() {
        this.getPageData("events");
    },
    filters: {
        fix_spaces: function (value) {
            if (!value) return ''
            value = value.replace("_", " ")
            return value
        }
    },
    watch: { 
        showAnalytics: function(newVal, oldVal) { // watch it
            console.log('Prop changed: ', newVal, ' | was: ', oldVal);
            if (newVal != this.dataType) {
                this.getPageData(newVal);

            }
        }
    }

};
</script>